<template>
    <div :class="classes" />
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: "normal"
        },
        vertical: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            return {
                mini: this.variant === "mini",
                mobile: this.variant === "mobile",
                normal: this.variant === "normal",
                horizontal: this.vertical === false,
                vertical: this.vertical === true
            };
        }
    }
};
</script>

<style scoped>
.mini.horizontal {
    height: 2px;
}

.normal.horizontal,
.mobile.horizontal {
    height: 0.8em;
}

.mini.vertical {
    width: 2px;
}

.normal.vertical,
.mobile.vertical {
    width: 0.8px;
}

@media all and (min-width: 820px) {
    .normal.horizontal,
    .mobile.horizontal {
        height: 1em;
    }

    .normal.vertical,
    .mobile.vertical {
        width: 1em;
    }

    .mobile {
        display: none;
    }
}
</style>
